<template>
  <div id="app">
    <header-box></header-box>
    <router-view></router-view>
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerBox from "./components/header.vue";
import footerBox from "./components/footer.vue";
export default {
  name: 'app',
  components: {
    headerBox,
    footerBox
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "/assets/scss/common.scss";
  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  #app {
    position: relative;
    min-width: 1200px;
    max-width: 100%;
    min-height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: $body-bg;
    .cont-box {
      width: 100%;
      min-height: calc(100% - 601px);
      padding-bottom: 80px;
    }
  }
  ul, li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
</style>
